module.exports = __webpack_public_path__ + "media/application/images/svgs/social_twitter-f95b67441cb08b0c6666b1483c0bb3e4.svg";